import React from 'react';

import { Spinner } from '@welbe/web-design-system';
import { Button } from '@welbe/design-system';

import { ModalCommunication } from './components/ModalCommunication/ModalCommunication';
import { Card } from './components/Card/Card';

import { ReactComponent as Sended } from 'App/assets/img/sended.svg';
import { ReactComponent as Pencil } from 'App/assets/img/pencil.svg';

import {
	Container,
	ContentContainer,
	EmptyContainer,
	CommunicationsContainer,
	SpinnerContainer,
	SubtitleEmpty,
} from './Communications.styles';

import { renderDate } from 'utils';
import { useCommunications } from './Communications.hooks';
import Analytics from 'helpers/analytics';

type CommunicationsProps = {
	onFetchCommunications: (communications: boolean) => void;
};

export const Communications = ({
	onFetchCommunications,
}: CommunicationsProps): JSX.Element => {
	const {
		campaign,
		showCommunicationModal,
		communication,
		isLoading,
		communicationCreatedDates,
		communicationCreatedTypes,
		getImage,
		handleNewCommunication,
		handleEditCommunication,
		handleCloseCommunication,
	} = useCommunications({ onFetchCommunications });

	const isEmpty = !campaign?.communications?.length;

	if (isLoading) {
		return (
			<SpinnerContainer>
				<Spinner size="40px" />
			</SpinnerContainer>
		);
	}

	if (isEmpty) {
		return (
			<>
				<SubtitleEmpty>
					La campaña ha cerrado sin comunicaciones programadas
				</SubtitleEmpty>
				<EmptyContainer>
					<Card loading />
					<Card loading />
					<Card loading />
				</EmptyContainer>
			</>
		);
	}

	return (
		<>
			<Container>
				<ContentContainer>
					<CommunicationsContainer>
						{campaign.communications?.map((communication: any) => (
							<Card
								key={communication.id}
								title={communication.name}
								subTitle={`Fecha de envio: ${renderDate(
									communication.sendingDateTime,
								)}`}
								icon={communication.status === 'SENT' ? <Sended /> : <Pencil />}
								file={getImage(communication)}
								fileExtension={communication.fileExtension}
								fileLabel={communication.communicationType.name}
								messageBody={communication.messageBody}
								handleAction={
									communication.status === 'SENT'
										? undefined
										: () => handleEditCommunication(communication)
								}
							/>
						))}
					</CommunicationsContainer>
				</ContentContainer>
				<Button
					key={'1'}
					onClick={() => {
						Analytics.track('campaign', 'add-communication');
						handleNewCommunication();
					}}
					width="250px"
				>
					+ Agregar comunicación
				</Button>
			</Container>
			{showCommunicationModal && (
				<ModalCommunication
					visible={showCommunicationModal}
					onClose={handleCloseCommunication}
					campaign={campaign}
					communication={communication}
					communicationCreatedTypes={communicationCreatedTypes}
					communicationCreatedDates={communicationCreatedDates}
				/>
			)}
		</>
	);
};
